module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"tool_title":"购买记录"},"en":{"tool_title":"Order Records"}}')
  delete Component.options._Ctor
}
